"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpSchema = exports.defaultFirstNameSchema = exports.ResetPasswordChangeSchema = exports.ResetPasswordSchema = exports.LoginSchema = exports.defaultCheckboxSchema = exports.defaultConfirmPassword = exports.defaultPasswordSchema = exports.defaultEmailSchema = void 0;
const yup = __importStar(require("yup"));
const constants_1 = __importDefault(require("@/constants"));
const FieldNames = __importStar(require("./field-names"));
exports.defaultEmailSchema = yup
    .string()
    .email()
    .required()
    .label('Email');
exports.defaultPasswordSchema = yup
    .string()
    .min(4, constants_1.default.signup.beAtLeast4)
    .max(50, constants_1.default.signup.notExceed50)
    .test('empty-check', constants_1.default.signup.passwordMustBe, (password) => (password === null || password === void 0 ? void 0 : password.length) !== 0)
    .required()
    .label('Password');
exports.defaultConfirmPassword = yup
    .string()
    .oneOf([yup.ref('password'), null], constants_1.default.signup.passwordsDoNotMatch)
    .required()
    .label('Password');
exports.defaultCheckboxSchema = yup
    .boolean()
    .oneOf([true])
    .required();
exports.LoginSchema = yup.object().shape({
    [FieldNames.LoginFieldNames.email]: exports.defaultEmailSchema,
    [FieldNames.LoginFieldNames.password]: exports.defaultPasswordSchema,
});
exports.ResetPasswordSchema = yup.object().shape({
    [FieldNames.ResetPasswordFieldNames.email]: exports.defaultEmailSchema,
});
exports.ResetPasswordChangeSchema = yup.object().shape({
    [FieldNames.ResetPasswordChangeFieldNames.password]: exports.defaultPasswordSchema,
    [FieldNames.ResetPasswordChangeFieldNames.confirmPassword]: exports.defaultConfirmPassword,
});
exports.defaultFirstNameSchema = yup
    .string()
    .label(constants_1.default.signup.firstName);
exports.SignUpSchema = yup.object().shape({
    [FieldNames.SignUpFieldNames.firstName]: exports.defaultFirstNameSchema,
    [FieldNames.SignUpFieldNames.email]: exports.defaultEmailSchema,
    [FieldNames.SignUpFieldNames.password]: exports.defaultPasswordSchema,
    [FieldNames.SignUpFieldNames.tos]: exports.defaultCheckboxSchema,
});
exports.default = {};
